<template>
    <div id="ContainerPatient">
      <div class="row">
          <div class="col-12">
            <MdTitle v-bind:Text="$t('dcsList.dpOfChildrenD')"/>
            <div class="row">
                <div class="col-sm-12 col-md-3" v-if="hasPermissionAdd()">                      
                    <!-- <MdButton
                      v-bind:Label="$t('dcsList.addexport')"
                      v-bind:ClassProp="false ? 'btn btn-primary my-3 btn-block' : 'btn btn-primary my-3 btn-block btn-login'"
                      v-on:click="GetAddDCS"
                      v-bind:IconClass="'ti-plus pr-1'"
                      v-bind:isReadOnly="!this.hasPermissionAdd()"
                      v-bind:Name="'btn_add_dcs'">
                    </MdButton> -->
                    <MdButton
                      v-bind:Label="$t('dcsList.addexport')"
                      v-bind:ClassProp="false ? 'btn btn-primary my-3 btn-block' : 'btn btn-primary my-3 btn-block btn-login'"
                      v-on:click="GetAddDCS"
                      v-bind:IconClass="'ti-plus pr-1'"
                      v-bind:Name="'btn_add_dcs'"
                    >
                    </MdButton>
                </div>
                <div class="col-sm-12" :class="{'col-md-9 mb-4': hasPermissionAdd(), 'col-md-12 mb-12': !hasPermissionAdd()}">
                    <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                        <div class="input-group" dir="ltr">
                            <input 
                              type="text" 
                              class="form-control"
                              :dir="dirInput"
                              v-model="parameter.SearchCriteria"
                              @keyup.enter="SearchDCS()"
                            >
                            <div class="input-group-append">
                                <MdButton 
                                  v-bind:Name="'btnsearchinput'"
                                  v-bind:VariantProp="'btn btn-sm search-attached'"
                                  v-bind:IconClass="'mdi mdi-magnify'"
                                  v-on:click="SearchDCS">
                                </MdButton>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
            <b-toast id="error-toast" :title="$tc('Msg.Error')" static no-auto-hide>
              {{ error_toast }}  
            </b-toast>
          </div>
      </div>
      <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.year')"
              v-bind:Options="YearList"
              v-bind:Model="year"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:Multiple="true"
              v-bind:IfUsevalidation="false"
              :Input="ChangeDropDownYear"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.month')"
              v-bind:Options="MonthList"
              v-bind:Model="month"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:Multiple="true"
              v-bind:IfUsevalidation="false"
              :Input="ChangeDropDownMonths"/>
          </b-col>
          <b-col md="6">
          <div class="text-center text-md-right mt-3">
            <button 
              v-on:click="SearchDCS"
              type="button"
              class="btn btn-primary btn-login mx-2 pull-right"												
              id="btnsearchinput">
              {{ $t('Shared.Search') }}
            </button>
          </div>
        </b-col>
        </b-row>
      <div class="row">
          <div class="col-12">
              <div>
                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/> 
                        <MdTable 
                        v-bind:fields="fields"
                        v-bind:items="items"
                        v-bind:totalRows="totalRows"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                        v-bind:currentPage="currentPage"
                        v-bind:perPage="perPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:refTable="'tablePatientdcs'"                      
                        v-bind:VisibleDownloadIcon="true"
                        v-bind:VisibleViewIcon="this.hasPermissionEdit()"
                        v-bind:VisibleDeleteIcon="true"                      
                        :downloadIconEvent="Download"            
                        :viewIconEvent="ViewIcon"
                        :emailIconEvent="EmailIcon"
                        :deleteIconEvent="DeleteIcon"           
                        :onRowSelected="onRowSelected"
                        :onFiltered="onFiltered"
                        :pageChanged="pageChanged"
                        :perPageFunction="PerPageFunction">
                      </MdTable>                    
              </div>
          </div>
      </div>
      <DxPoPupTable v-if="isVisible" 
              :Title="$t('dcs.review')"
              :closeWindow="closeRepWindow"
              :isVisible="isVisible"
              :items = "spreadsheet"
      />
    
    <ModalViewDCS 
        v-bind:GroupCreationId="GroupCreationId"
        v-bind:Version="Version"     
        v-bind:Year="Year"     
        v-bind:Month="Month"      
        v-bind:ReadOnly="isReadOnly"       
        @OnModalViewDCS="OnModalViewDCS" 
        @OnDeleteModalViewDCS="OnModalDeleteDCS"       
        v-if="VisibleModalViewDCS"
        v-bind:ModalId="'modalIdViewDCS'"
        v-bind:TitleWindow="TitleModalViewDCS"     
    >

    </ModalViewDCS>

    <MdPasswordDlg v-if="showSignPassword" 
      v-bind:Type="TypePassWord"
      v-bind:VerificationType="'SupervisorPassword'"
      @getModalPassword="onModalPasswordResult($event)"
    />

    <ModalSendMail
      v-bind:TitleWindow="'Send by E-Mail'"
      @ModalClickOk="SendEmail"  
      v-bind:ModalId="modalSendMail"
      v-bind:Subject="conformSubject">
    </ModalSendMail>
    </div>
</template>
  
  <script>
  import EnumService from '@/services/enum.service' 
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import DCSService from '@/services/dcs.service'
  import { EventBus } from '@/event-bus.js';
  import Permission from '@/common/Permission'
  
  export default {
    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'DcsList',
    components: {
     // Patient
    },
    data() {
      return { 
        GroupCreationId:"",
        Version:"",
        Year:"",
        Month:"",
        VisibleModalViewDCS:false,
        search_criteria: "",
        error_toast: "",
        ShowMessageIsEmpty:false,
        //Menu : this.$store.state.leftMenu,
        //permission: [],
        TitleModalViewDCS:"",
        Loading:true,
        Mode:'',  
        FieldsDateArr:['dob'],
        status:{
          selected:true,
          value:true,
          text:this.$t('Shared.Active')
        },    
        parameter:{
          SearchCriteria:'',
          PageNumber : 0,
          PageSize:0,
          Status: true,
          MonthList: [],
          YearList: []
        },
        OptionsRightMenu:{
              visible:true,
              ItemsList:[],
              btnvisible:false,
              itemdisabled: false,
              PatientCode:'',
              Mode:this.edit_mode,
              favButtonAtion:false          
          },
       
        fields: [
          { key: 'year', sortable: true, label: this.$t('Shared.year'), class: 'text-rigth' },  
          { key: 'monthName', sortable: true, label: this.$t('Shared.month'), class: 'text-rigth' },
          { key: 'version', sortable: true, label: this.$t('Shared.IncVers'), class: 'text-rigth' },
          { key: 'totalCharges', sortable: true, label: this.$t('dcs.TCharges'), class: 'text-rigth',formatter: value => {return Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(value)} },  
          { key: 'noTransactions', sortable: true, label: this.$t('Shared.Transactions'), class: 'text-rigth' },
          { key: 'noInvoices', sortable: true, label: this.$t('dcs.Invoices'), class: 'text-rigth' },
          { key: 'groupCreationId', sortable: true, label: this.$t('dcs.gcid'), class: 'text-rigth' }, 
          ],
  
        pageOptions: [5, 10, 15 ],
        totalRows: 4,
        currentPage: 1,
        perPage: 10,
        filter: null,
        filterOn: [],
        items: [],
        selected: [],
        Header:{},
        isReadOnly: false,
        refTable: 'selectableTable',
        selectedRow: '',
        isVisible: false,
        spreadsheet: [],
        UserIdSelected: '',
        showSignPassword: false,
        TypePassWord:'Sign',
        month: [],
        MonthList: EnumService.Months,
        year: [],
        YearList: [],
        emailGroupCreationId: '',
        emailVersion: 0,
        modalSendMail: "modalSendMail",
        conformSubject: '',
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr', 
      }
    },
  
    computed: {
        sortOptions() {
          // Create an options list from our fields
          return this.fields
            .filter(f => f.sortable)
            .map(f => {
              return { text: f.label, value: f.key }
            });
        }
    },
      
    methods: {

      EmailIcon(row) {
        this.emailGroupCreationId = row.groupCreationId
        this.emailVersion = row.version
        this.conformSubject = `${row.groupCreationId}ver${row.version.toString()}`
        this.$bvModal.show(this.modalSendMail);
      },

      async SendEmail(To, Cc, Subject, Body) {  
        this.$emit('load', true)
        let params = {
            to: To,
            cc: Cc ? Cc : null,
            subject: Subject,
            body: Body ? Body : null,
            groupCreationID: this.emailGroupCreationId ? this.emailGroupCreationId : null,
            version: this.emailVersion ? this.emailVersion.toString() : null
        }
        await DCSService.dcseMail(params).then(response => {
          let resp = response

          if (resp.data.success == true)
            this.showMessage('DCS by e-mail','The e-mail was sent')
          else 
            this.showMessage('DCS by e-mail',resp.data.errorMessage,"error");

          this.$emit('load', false);
        }).catch(error => {
          this.$emit('load', false);
          if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        })
        this.$emit('load', false) 
      },

      ChangeDropDownMonths(item) {
        this.parameter.MonthList = [];
        item.forEach(it => {
          this.parameter.MonthList.push(it.value)
        });
        this.currentPage = 1;     
        this.getDCSList()    
      },

      ChangeDropDownYear(item) {
        this.parameter.YearList = [];
        item.forEach(it => {
          this.parameter.YearList.push(it.value)
        });
        this.currentPage = 1;      
        this.getDCSList()
      },

      getYears() {
        const currentYear = new Date().getFullYear();
        const ayears = Array.from({ length: 100 }, (_, i) =>  currentYear - i);
        let years = []

        ayears.forEach(year => {
          years.push({'name': year, 'value': year})
        });

        this.YearList = years;           
      },
  
      pageChanged (page) {            
        this.currentPage = page;    
        this.getDCSList();   
      },
  
      PerPageFunction(perpage){
        this.perPage = perpage;  
       this.currentPage = 1;
       this.getDCSList();   
      },
      async getDCSList(){
        this.parameter.PageSize = this.perPage;
        this.parameter.PageNumber = this.currentPage;
        this.$emit("load", true)
        await DCSService.listing(this.parameter).then((response) => {
          this.items = response.data;
          if(response.status == '200' && response.data && response.data.length > 0){
            this.$emit('load', false);
            let headerString = response.headers["x-pagination"];
            this.Header = JSON.parse(headerString);
            this.totalRows = this.Header.TotalCount;
          }
          if(this.items.length === 0){
            this.$emit('load', false);
            this.ShowMessageIsEmpty = true;
          } 
        }).catch(error => {
          this.$emit('load', false);
          this.showResponseErrorMessage(error);
          /*if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }*/
        })
      },

      onModalPasswordResult(result){      
          if(result.Event === 'Ok'){   
            if(result.status === true) {          
              if(this.selectedRow){
                this.DeleteDCS(this.selectedRow);             
              }
          }else{
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.InvalidSupervisorPass'),"error");
          }
        }
        this.showSignPassword = false;
    },

      closeRepWindow(){
        this.isVisible = false
      },

      ViewIcon(row) {     
      /*  console.log(row);
        this.GroupCreationId = row.groupCreationId;
        this.Version = row.version ? row.version.toString():"";
        this.Year = row.year ? row.year.toString():"";
        this.Month = row.month ? row.month.toString():"";

        this.TitleModalViewDCS = "YEAR "+row.year +" / "+"MONTH "+row.month+" / "+"VERSION "+row.version+" / "+
        "TOTAL CHARGES "+row.totalCharges+" / "+"TRANSACTIONS "+row.noTransactions+" / "+"INVOICES "+row.noInvoices
       
        this.VisibleModalViewDCS = true;*/

        this.$router.push({ name: "dcs-detail", params: { groupId: row.groupCreationId,year:row.year,month:row.monthName,monthNumber:row.month, version:row.version,totalcharges:row.totalCharges,transactions:row.noTransactions,invoice:row.noInvoices } });
      },

      OnModalViewDCS(){       
        this.VisibleModalViewDCS = false;
      },

       OnModalDeleteDCS(row){
        this.VisibleModalViewDCS = false;       
        this.DeleteDCS(row);
       
      },

      generateTable(content){
          content = content.replace(/(['"])/g, "")
          let headerElements = content.slice(0, content.indexOf('\r')).split(",")
          let generalRows = content.slice(content.indexOf('\n') + 1, content.length - 2).split('\r\n')
          let rowElements = []
          generalRows.forEach(element => {
            let subElement = element.split(',')
            rowElements.push(subElement)
          });
          let rows = []
          for(var y = 0; y < rowElements.length; y++){
            let thing = {};
            for(var i = 0; i < headerElements.length; i++){
              thing[headerElements[i]] = rowElements[y][i];
            }
            rows.push(thing)
          }
          this.spreadsheet = rows
      },

      DownloadIcon(/*row*/){  
        /*this.generateTable(row.xcelReport)
        this.DownloadDCS(row)*/
    
      },

      jsonToCsv(jsonData) {
          let csv = '';
          // Get the headers
          let headers = Object.keys(jsonData[0]);
          csv += headers.join(',') + '\n';
          // Add the data
          jsonData.forEach(function (row) {
              let data = headers.map(header => JSON.stringify(row[header])).join(','); // Add JSON.stringify statement
              csv += data + '\n';
          });
          csv = csv.replace(/\\"/g, "")
          return csv;
      },

      DownloadDCS(row) {
        try{
          let csv = this.jsonToCsv(this.spreadsheet)
          const dataUri = window.URL.createObjectURL(
            new Blob( [csv], { type: "text/csv" } )
          )
          //window.open(dataUri)
          const anchor = document.createElement('a');
          anchor.href = dataUri
          anchor.target = '_blank';
          anchor.download = 'DCS' + row.month + row.year + 'ver' + row.version + '.csv';
          anchor.click();
        }catch(error) {
          this.$emit('load', false);
          console.log(error)
          if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('dcs.dFaildMsg'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        }
      },

      DeleteIcon(row){
        this.selectedRow = row;
        this.$bvModal.msgBoxConfirm(this.$t('dcsList.resetMsg'), {
					title: this.$t('Shared.Reset'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
          id: 'modal_delete_dcs'
				})
          .then(value => {
            if(value){
              this.showSignPassword = true;
            }else{
              this.showSignPassword = false;
            }
          })    
      },

      async DownloadUrl(url, filename) {          
           const data = await fetch(url)
           const blob = await data.blob()
           const objectUrl = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.setAttribute('href', objectUrl)
          link.setAttribute('download', filename)
          link.style.display = 'none'
          document.body.appendChild(link)                          
          link.click()                          
          document.body.removeChild(link)
      },


      Download(row) {  
        var baseurl = this.$store.state.apiurl.replace('/api/', '');                
       DCSService.dcsdownload(row.groupCreationId,row.version)
            .then((response) => {      
               if (response.data) {
                this.FullUrl = baseurl+response.data.url;   
                this.DownloadUrl(this.FullUrl,response.data.fileName);                
               }  
               
         })
         .catch(error => {          
            if(error.response.status === 400 ){
                 this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
            }else{
               this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
         }); 
            
      },

      async DeleteDCS(row){        
        this.$emit('load', true);  
             await DCSService.dcsDelete(row.year, row.month, row.version)
                .then(() => {                
                  this.getDCSList();
                  this.$emit('load', false);
                  this.showMessage(this.$t('Msg.Success'),this.$t('Msg.Rrddeleted'));
                })
                .catch((error) => {
                  this.$emit('load', false);  
                    if(error.response.status === 400 ){
                     this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }else{
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                     }                   
                });
    },

      onRowSelected(items) {
        this.selected = items
      },
  
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },

      Error(row){
        console.log(row); 
    },

    Warning(row){
        console.log(row);
    },
  
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
  
      selectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.selectRow(2)
      },
  
      unselectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.unselectRow(2)
      },
  
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },

      GetAddDCS(){
        this.Mode="Add"; 
        this.OptionsRightMenu.btnvisible = true;
        this.OptionsRightMenu.ItemsList = EnumService.PatientItems;
        this.OptionsRightMenu.Mode = "Add";
        this.$emit('getBtnRightMenu', this.OptionsRightMenu);
        this.emitDataforFavorites();
        EventBus.$emit('onUpdatedMenu', '');
        this.$router.push({ name: "dcs-add"}).catch(()=>{});
      },
  
      info(item, index) {
        alert(item.FirstName,index);
      },
  
      SearchDCS(){
        this.items = []
        this.currentPage = 1;
        this.parameter.PageNumber = 1;
        this.totalRows = this.items.length;
        this.getDCSList();
      },
  
      ChangeStatus(status){
       // this.status.value = status ? status.value : '';
        this.status = { value:''};
        if(status){
             this.status.value = status.value;
             this.status.text = status.text;
             this.status.selected = status.selected;
        }
        this.items = [];
        this.totalRows = 0;
        this.getPatients();
      }
    },
  
    created(){
        this.getDCSList()
        this.getYears();
    },
  
    mounted() {
     // this.getPatients();
      this.OptionsRightMenu.ItemsList = []
      let layoutStatus = this.$store.state.layoutStatus;
      switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = true;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }
    },
  
    updated() {
      this.OptionsRightMenu.btnvisible = false;
      this.OptionsRightMenu.ItemsList = [];
      this.$emit('getBtnRightMenu', this.OptionsRightMenu);    
    },
  
  };
  </script>
  
  <style>
    @import '../../../assets/css/Patients/PatientList.css';
  </style>
  